/**
 * Pie de una lista paginada: cuántas hay en total y, si no caben en una página, «Anterior / Siguiente». El mismo patrón de
 * Compras y Gastos (hallazgo 4-H9), ahora también en los cierres de sucursal y los retiros (hallazgo T19).
 */
import { Button } from '@/componentes/ui/button.tsx';

export function PieDePaginas({ total, limite, pagina, setPagina, nombre, testid }: { total: number; limite: number; pagina: number; setPagina: (p: number) => void; nombre: string; testid: string }) {
  const paginas = Math.max(1, Math.ceil(total / limite));
  return (
    <div className="mt-2 flex items-center justify-between text-sm text-muted-foreground" data-testid={testid}>
      <span>
        {total} {nombre}
        {paginas > 1 ? ` · página ${pagina} de ${paginas}` : ''}
      </span>
      {paginas > 1 ? (
        <div className="flex gap-2">
          <Button size="sm" variant="outline" disabled={pagina <= 1} onClick={() => setPagina(pagina - 1)} data-testid={`${testid}-anterior`}>
            Anterior
          </Button>
          <Button size="sm" variant="outline" disabled={pagina >= paginas} onClick={() => setPagina(pagina + 1)} data-testid={`${testid}-siguiente`}>
            Siguiente
          </Button>
        </div>
      ) : null}
    </div>
  );
}
